import { render, staticRenderFns } from "./MiniArea.vue?vue&type=template&id=2f95bc45&scoped=true&"
import script from "./MiniArea.vue?vue&type=script&lang=js&"
export * from "./MiniArea.vue?vue&type=script&lang=js&"
import style0 from "./MiniArea.vue?vue&type=style&index=0&id=2f95bc45&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f95bc45",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f95bc45')) {
      api.createRecord('2f95bc45', component.options)
    } else {
      api.reload('2f95bc45', component.options)
    }
    module.hot.accept("./MiniArea.vue?vue&type=template&id=2f95bc45&scoped=true&", function () {
      api.rerender('2f95bc45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chart/MiniArea.vue"
export default component.exports